module.exports = __webpack_public_path__ + "img/u890.e75a052e.svg";